import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createRankApi, storeRankApi } from './rankSlice';
import isEmpty from 'lodash/isEmpty';
import { RequestBodyConverter } from '../RequestBodyConverter';
import RankForm from './RankForm';
// import { initialValues  } from './initialValues-testing';

function RankCreate() {
    const [resetCount, setResetCount] = useState(0);
    const { model: initialValues, pictureAttributeNames } = useSelector((state) => state.heroSaga.rank);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        await values.convertPictures(rawValues, pictureAttributeNames);
        values = values.data;
        dispatch(storeRankApi({ navigate, values }));
    };

    useEffect(() => {
        if (isEmpty(initialValues)) {
            dispatch(createRankApi());
        }
    }, []);

    return (
        <RankForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default RankCreate;
